export default __webpack_public_path__ + "static/media/CloseSurveyDark.df39df39.svg";